<script setup>
import { usePanelStore } from '~/store/panel'
import xMod from '~/components/common/xMod.vue'
import { useFutureStore } from '~/store/future'

const { t } = useI18n()
const future = useFutureStore()
const panel = usePanelStore()
const types = computed(() => [{
  key: 'LIMIT',
  title: t('限价'),
  disabled: [30].includes(future.accountType),
}, {
  key: 'MARKET',
  title: t('市价'),
}, {
  key: 'TRIGGER',
  title: t('计划委托'),
  disabled: [30, 10].includes(future.accountType),
  hide: panel.pe !== 1,
}].filter(i => !i.hide))

function tabChange(key) {
  panel.type = key
}

watch(() => future.accountType, () => {
  if (future.isGrants) {
    nextTick(() => {
      panel.type = 'MARKET'
    })
  }
  if (future.isBonus) {
    nextTick(() => {
      panel.type = 'LIMIT'
    })
  }
})
</script>

<template>
  <div class="text-xs whitespace-nowrap">
    <xMod :tab="panel.type" :tabs="types" header-class="!px-0 !h-7" @tab-change="tabChange" />
  </div>
</template>
